export const ecosystemSlug = "MUSAMERDA"; // current ecosystem slug

export const owneremail = "gerencia@festivaldealmagro.com"; // current ecosystem owner
